import { Moment } from 'moment';
import React, { FC } from 'react';
import { HumanisedDate } from '../humanised-date';
import styles from './date-from-to.module.css';

interface DateFromTo {
  from?: Moment | null;
  to?: Moment | null;
}
export const DateFromTo: FC<DateFromTo> = ({ from, to }) => (
  <>
    {from && <HumanisedDate timestamp={from} />}
    {from && to && <span className={styles.separator}>-</span>}
    {to && <HumanisedDate timestamp={to} />}
  </>
);
